module.exports = __webpack_public_path__ + "img/img2-1.850ecb93.png";